import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useAuth } from '../../context';
import { register } from '../../api/customers';
import { Form, FormField, SubmitButton } from '../../components/forms';
import { ActivityIndicator } from '../../components/ui';
import styles from './RegisterPage.module.css';

const validationSchema = Yup.object().shape({
  email: Yup.string().required().email().label('Email'),
});

interface RegisterFormValues {
  email: string;
}

export function RegisterPage() {
  const navigate = useNavigate();
  const { email: savedEmail, setEmail } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (values: RegisterFormValues) => {
    setEmail(values.email);
    setLoading(true);
    setError(null);

    const result = await register(values.email);
    setLoading(false);

    if (!result.ok) {
      setError(result.problem || 'Registration failed');
      return;
    }

    if (!result.data?.success) {
      setError(result.data?.error?.message || 'Registration failed');
      return;
    }

    alert('Registration successful! Check your email to set up your password, then log in.');
    navigate('/');
  };

  return (
    <div className={styles.container}>
      <ActivityIndicator visible={loading} />
      <h1 className={styles.title}>Register</h1>
      <p className={styles.description}>
        Enter your email to create an account. We'll send you a link to set up your password.
      </p>
      <Form<RegisterFormValues>
        initialValues={{
          email: savedEmail || '',
        }}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        <FormField
          name="email"
          icon="✉"
          placeholder="Email"
          type="email"
          autoComplete="email"
          autoCapitalize="none"
        />
        {error && <p className={styles.error}>{error}</p>}
        <SubmitButton title="Register" theme="secondary" />
      </Form>
      <button className={styles.backButton} onClick={() => navigate('/')}>
        Back to Login
      </button>
    </div>
  );
}

export default RegisterPage;